export const PHONE_REGEX = /^\+?\d{6,15}$/;

export const numericChangeHandler =
  (cb: (a: number | undefined) => void) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (!newValue || /^[0-9]*\.?[0-9]*$/.test(newValue)) {
      cb(Number(newValue) || undefined);
    }
  };

export const imgSrc = 'https://test.chorleybs.co.uk/media/request-callback.jpeg';

export const apiUrl = 'https://test.chorleybs.co.uk';
